module.exports = __webpack_public_path__ + "static/img/get-to-the-management-team_5.34f1145.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/get-to-the-management-team_5.png
// module id = Zmgh
// module chunks = 0